import React, { useContext } from 'react';
import { Context as ConfigContext } from '../Config';
import WithTitle from '../componentsInternal/WithTitle';
import { useArticlePageData } from '../hooksInternal/useArticlePageData';
import { usePageClassName } from '../hooksInternal/usePageClassName';
import { useTranslation } from '../hooks/useTranslation';
import { ArticleFullContext } from '../contexts';
import ErrorPage from './error';
import Error404Page from './error404';
import Error401Page from './error401';
const ArticlePage = ({ match }) => {
    const { t } = useTranslation();
    usePageClassName('article-page');
    const { articleId } = match.params;
    const articleMatch = articleId.match(/^\d+/);
    let _articleId = articleMatch ? articleMatch[0] : '';
    const { data, fetchingStatus } = useArticlePageData(_articleId);
    const { pages, pageLoadingIndicator: Loader } = useContext(ConfigContext);
    if (fetchingStatus === 'is-fetching' || fetchingStatus === 'not-started')
        return React.createElement(Loader, null);
    if (fetchingStatus === 'NotFound')
        return React.createElement(Error404Page, null);
    if (fetchingStatus === 'LoginRequired')
        return React.createElement(Error401Page, null);
    if (fetchingStatus !== 'has-fetched' || !data || !data.article)
        return React.createElement(ErrorPage, null);
    const article = data.article;
    const Page = pages.article.component;
    const title = t('pageTitles.article', '{{article.title}}', { article });
    return (React.createElement(ArticleFullContext.Provider, { value: article },
        React.createElement(React.Fragment, null,
            React.createElement(WithTitle, { title: title },
                React.createElement(Page, { article: article })))));
};
ArticlePage.displayName = 'ArticlePage';
export default ArticlePage;
//# sourceMappingURL=article.js.map